import React from 'react';

import {connect} from 'react-redux';
import {modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';

import cs from 'classnames';

import {MenuList, MenuListItem as Item} from '~/components/common/MenuList';
import DropDown from '~/components/common/DropDown';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInput';
import Spinner from '~/components/common/Spinner';
import {track} from '~/misc/metrics';

import css from './style.css';

const byAge = 'Age';

const select = {
  Age: {
    title: 'Age',
    asc: 'Newest',
    desc: 'Oldest',
    preferredOrder: 'asc',
  },
  Price: {
    title: 'Price',
    asc: 'Smaller',
    desc: 'Bigger',
    preferredOrder: 'desc',
  },
};

const handleSelect = (props, value) =>
  () => {
    const sortOrder = select[value].preferredOrder || 'desc';
    const query = props.query || {};
    if (query.sort_order === sortOrder
      && query.sort_by === value) {
      return null;
    }
    return props.loadsSort({
      ...query,
      sort_by: value,
      sort_order: sortOrder,
    }, true);
  };

const orderTitle = (type, value) => {
  const map = select[type];
  if (!map) {
    return null;
  }

  return map[value];
};

const SortSelect = (props) => {
  const query = props.query;
  const sortBy = query.sort_by || byAge;
  const sortOrder = query.sort_order || 'asc';
  const userIsLoggedIn = props.userIsLoggedIn;
  const showLogIn = props.showLogIn;
  const key = props.isSimilar ? 'similar' : 'loads';

  const orderValue = orderTitle(sortBy, sortOrder);

  const toggleOrder = () => {
    const newValue = (query.sort_order === 'desc') ? 'asc' : 'desc';
    return props.loadsSort({...query, sort_order: newValue});
  };
  
  const toggleShow = (newValue) => {
    if (query.show_option === newValue) {return;}
    if (newValue === 'My favorites') {
      track('save and hide loads', {'show my favorite': 1});
    }
    return props.loadsSort({...query, show_option: newValue});
  };

  return (
    <div className={css.sortWrapper}>
      {props.fetching ? (
        <div className={css.spinner}>
          <Spinner scalable={true} qa='sort-by'/>
        </div>
      ) : null}
      <div className={css.wrap}>
        <span className={css.label}>Sort By</span>
        <DropDown
          id={`sortBy${ key}`}
          trigger={
            <LabeledInput>
              <Button
                mods={['dropdown', 'wide']}
                className={cs(css.selectWrapper, css.selectSortBy)}
                data-qa='sort-by-selector'
              >
                <span className={css.selected} data-qa='sort-by-value'>{select[sortBy].title}{orderValue ? (` - ${orderValue}`) : ' '}</span>
                <span className={css.iconDown}></span>
              </Button>
            </LabeledInput>
          }
          closeByClick={true}
          content={
            <div className={css.dropdownWrap} data-qa='sort-by-dropdown'>
              <MenuList>
                {Object.keys(select).map(k =>
                  <Item key={k} fn={handleSelect(props, k)} title={select[k].title} data-qa={`sort-by-option-${k}`}/>
                )}
              </MenuList>
            </div>
          }
        />

        <Button data-qa='order-by-button' onClick={toggleOrder} className={cs(css.selectWrapper, css.selectOrder)}>
          <span
            className={cs(
              css.iconUp,
              query.sort_order !== 'asc' && css.inactive
            )}
          ></span>
          <span
            className={cs(
              css.iconDown,
              query.sort_order !== 'desc' && css.inactive
            )}
          ></span>
        </Button>

      </div>
    </div>
  );
};

export default connect(({user: {isLoggedIn}}) => ({
  userIsLoggedIn: isLoggedIn,
}), mapDispatch({
  showLogIn: () => modalChange('login', 'anonymous_banner'),
}))(SortSelect);



// WEBPACK FOOTER //
// ./src/pages/CapacityRatio/compontents/RatioTable/SortSelect/index.js